import { giphyDarkGrey } from '@giphy/js-brand'
import { CSSProperties, ForwardedRef, forwardRef, isValidElement, ReactNode, SyntheticEvent } from 'react'
import { ControlSize, Gradient } from 'types'
import { Button as ButtonComponent, Icon, Label, Loader } from './style'

export type ButtonProps = {
    children?: ReactNode
    className?: string
    color?: string
    disabled?: boolean
    gradient?: Gradient
    href?: string
    icon?: ReactNode
    iconLocation?: 'left' | 'right'
    loading?: boolean
    loadingColor?: string
    role?: string
    roleDescription?: string
    size?: ControlSize
    style?: CSSProperties
    tabIndex?: number
    target?: string
    textColor?: string
    title?: string
    iconGradient?: Gradient | undefined
    onClick?: (e: SyntheticEvent<HTMLButtonElement, Event>) => void
}

const Button = (
    {
        children,
        color = giphyDarkGrey,
        disabled = false,
        gradient,
        href,
        icon,
        iconLocation = 'right',
        loading = false,
        loadingColor,
        size = 'small',
        target,
        textColor,
        iconGradient = undefined,
        ...rest
    }: ButtonProps,
    ref: ForwardedRef<any>
) => (
    <ButtonComponent
        {...rest}
        as={href ? 'a' : 'button'}
        controlColor={color}
        controlSize={size}
        dimmed={disabled}
        disabled={disabled || loading}
        gradient={gradient}
        href={href}
        ref={ref}
        target={href ? target : undefined}
        textColor={textColor}
        type={href ? undefined : 'button'}
        iconGradient={iconGradient}
    >
        {loading ? (
            <Loader color={loadingColor} size="small" />
        ) : (
            <>
                {icon && iconLocation === 'left' && <Icon>{icon}</Icon>}
                {children && (isValidElement(children) ? children : <Label>{children}</Label>)}
                {icon && iconLocation === 'right' && <Icon>{icon}</Icon>}
            </>
        )}
    </ButtonComponent>
)

export default forwardRef(Button)
